/*
 * 提供简化 React Component 组件声明的工具类.
**/
import React from 'react';

export const BaseComponent = class extends React.Component {};
